export default "__VITE_ASSET__ClhP$AQd__"